export enum VentureProjectTypeModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
